<template>
    <v-dialog max-width="600px" v-model="dialog">
        <v-btn flat slot="activator" color="primary">Confirm Preference</v-btn>
        <v-card>
            <v-card-title>
                <span class="headline font-weight-bold">Let's get a few more details about your top pick:</span> 
                <!-- <v-alert
                :value="true"
                color="primary"
                icon="info"
                class="caption text-lg-justify"
                outline>
                You have seleect
              </v-alert>  -->
            </v-card-title>

            <v-card-text>
                <v-form class="px-3" ref="form">
                    <v-textarea outline label="Why choose this solution as your top pick?" v-model="firstprefdetailwhychoosetopsolution" :rules="textInputRules"></v-textarea>

                    <v-textarea 
                    outline 
                    :label="firstprefvaluepropositionLabelText" 
                    v-model="firstprefvalueproposition" 
                    :hint="firstprefvaluepropositionHintText"
                    :rules="textInputRules"></v-textarea>


                    <v-textarea 
                    outline 
                    label="After the occurance of which event, would you suggest that the customer pain point is resolved?" 
                    v-model="firstprefdetailpointofcustomerpainpointresolution" 
                    :rules="textInputRules"></v-textarea>
                    
                    <v-textarea outline label="What are the traits of the early adopters who will be testing the solution concept?" v-model="firstprefdetailearlyadoptertraits" :rules="textInputRules"></v-textarea>

                    <v-textarea outline label="How would you plan to monetize the solution concept?" v-model="firstprefdetailprimarymonetizationstrategy" :hint="firstprefdetailprimarymonetizationstrategyLabel" :rules="textInputRules"></v-textarea>
                    

                    <v-checkbox v-model="firstprefdetaildoesthissolutionhavedisruptivequalities" label="This solution concept has disruptive qualities"></v-checkbox>
                    <!-- <v-btn flat color="primary" @click="submit" :loading="loading">Add details</v-btn> -->
                    <!-- <v-btn flat to="/addproductgoals" color="primary" class="mx-2 mt-3" :loading="loading">Add details</v-btn>  -->
                    <!-- <v-btn flat to="/addproductgoals" color="primary" class="mx-2 mt-3" :loading="loading">Complete Step 3</v-btn> -->
                    <v-btn flat @click="dialog = false">Cancel</v-btn>
                    <v-btn flat to="/bifprocessmodel4" color="primary" class="mx-2 mt-3" :loading="loading">Complete Step 3</v-btn>
                    
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import db from '../fb'
import gvars from '../globalvariables'

export default {
    name: '',
    data() {
        return{
            firstprefdetailwhychoosetopsolution: 'The client is interested in overall task management which places an emphasis on clarity and prioritisation. The current solution concept can also train the end user in developing prioritisation as a skill.',
            firstprefdetailpointofcustomerpainpointresolution: 'When task management and personal planning is done through a streamlined system and task completion rate per month improves by 20%.',
            firstprefdetailearlyadoptertraits: 'Tech savvy, very poor task management skills and looking to improve professional productivity levels',
            firstprefdetailprimarymonetizationstrategy: 'We plan to monetize this innovation via advertising',
            firstprefdetailprimarymonetizationstrategyLabel: '*Determining this at the current stage can help incorporate this strategy into the designs at an early stage.',
            firstprefdetaildoesthissolutionhavedisruptivequalities: false,
            firstprefvalueproposition: 'A simple Task management solution for personal and professional use, influenced by the Eisenhower method.',
            firstprefvaluepropositionLabelText: 'How would you briefly describe the primary value proposition for this solution?',
            firstprefvaluepropositionHintText: 'A value propostion helps the customer understand what value they acquire when they use your solution.',
            
            textInputRules: [
                    v => !!v || 'This field is required',
                    v => v.length >= 3 || 'Minimum length is 3 characters'
                ],
            loading: false,
            dialog: false
        }
    },
    methods: {
        submit() {

             if(this.$refs.form.validate()) {
            //console.log(this.nameofthesolution, this.briefdescriptionofthesolution)
            this.loading = true;
             

            //details = {}

            const firstprefdetails = {
                firstprefdetailwhychoosetopsolution: this.firstprefdetailwhychoosetopsolution,
                firstprefvalueproposition: this.firstprefvalueproposition,
                firstprefdetailpointofcustomerpainpointresolution: this.firstprefdetailpointofcustomerpainpointresolution,
                firstprefdetailearlyadoptertraits: this.firstprefdetailearlyadoptertraits,
                firstprefdetailprimarymonetizationstrategy: this.firstprefdetailprimarymonetizationstrategy,
                firstprefdetaildoesthissolutionhavedisruptivequalities: this.firstprefdetaildoesthissolutionhavedisruptivequalities
            }

            //details['prefs'] = firstprefdetails;
 

            //
            //xuWrU7qOYXxLjL97QoCe

        db.collection('projects').doc(this.getProjectID()).update(firstprefdetails).then(() => {
          //console.log("added to db!", docRef.id)
          this.loading = false;
          this.dialog = false;
          this.$emit('firstprefdetailsconfirmed')
       });


        const metric = {
                metrictitle: this.metrictitle,
                metriccategory: 'Solution space'
            }
 

            //Yx3r6dHUeFFdGvY6Acvy

           db.collection('projects').doc(this.getProjectID()).collection('metrics').add(metric).then(() => {
          //console.log("added to db!", docRef.id)
          //nameofthesolution = '';
          //briefdescriptionofthesolution = '';
          this.loading = false;
          this.dialog = false;
          //this.$emit('projectadded')
       });



        const bmcelement = { 
                bmcelementdescription: this.firstprefvalueproposition,
                bmcelementtype: 'Value proposition',
                bmcelementisprimary: true
            }
 

            //Yx3r6dHUeFFdGvY6Acvy

           db.collection('projects').doc(this.getProjectID()).collection('bmcelements').add(bmcelement).then(() => {
          //console.log("added to db!", docRef.id)
          //nameofthesolution = '';
          //briefdescriptionofthesolution = '';
          this.loading = false;
          this.dialog = false;
          //this.$emit('projectadded')
       });

       


             }
        },
    getProjectID(){
      return gvars.PROJECTID;
    } 
    }
}
</script>
